import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    messager: {}
  },
  getters: {},
  mutations: {
    setMessager(state, value) {
      state.messager = value;
    }
  },
  actions: {},
  modules: {}
});
